// On web this is up to the browser that shows the notifications
export default () => {};
